import api from './api'

const userFolderService = {
  async getUserFolders(params = {}) {
    try {
      params['_no_pagination_'] = 1
      const response = await api.get('/admin/user-folders?_with_[mails]', { params })
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Get user folders error:', error)
      throw new Error(error.response?.data?.message || 'فشل في جلب المجلدات')
    }
  },

  async createUserFolder(data) {
    try {
      const response = await api.post('/admin/user-folders', data)
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Create user folder error:', error)
      throw new Error(error.response?.data?.message || 'فشل في إنشاء المجلد')
    }
  },

  async updateUserFolder(id, data) {
    try {
      const response = await api.put(`/admin/user-folders/${id}`, data)
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Update user folder error:', error)
      throw new Error(error.response?.data?.message || 'فشل في تحديث المجلد')
    }
  },

  async deleteUserFolder(id) {
    try {
      const response = await api.delete(`/admin/user-folders/${id}`)
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Delete user folder error:', error)
      throw new Error(error.response?.data?.message || 'فشل في حذف المجلد')
    }
  }
}

export default userFolderService 